import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ngfModule } from 'angular-file';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { AppRoutingModule } from '.././app-routing.module';
import { HomeLayoutComponent } from './home-layout/home-layout.component';
import { OnboardingLayoutComponent } from './onboarding-layout/onboarding-layout.component';
import { SharedModule } from '../shared/shared.module';
import { ModalsModule } from '../modals/modals.module';
import { NavigationComponent } from '../core/components/navigation/navigation.component';
import { SmNavComponent } from '../core/components/sm-nav/sm-nav.component';
import { SmLayoutComponent } from './sm-layout/sm-layout.component';
import { BellNotificationComponent } from '../core/components/bell-notification/bell-notification.component';
import { ExpenseQuickAddButtonComponent } from '../shared/component/expense-quick-add-button/expense-quick-add-button.component';
import { OfficeNavComponent } from '@pages/office/office-nav/office-nav.component';
import { NavbarClockInComponent } from '../core/components/navbar-clock-in/navbar-clock-in.component';

@NgModule({
  declarations: [
    OnboardingLayoutComponent,
    NavigationComponent,
    HomeLayoutComponent,
    SmNavComponent,
    SmLayoutComponent,
    BellNotificationComponent,
    NavbarClockInComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    ModalsModule,
    AppRoutingModule,
    ngfModule,
    FormsModule,
    NgSelectModule,
    ExpenseQuickAddButtonComponent,
    OfficeNavComponent,
  ],
  exports: [HomeLayoutComponent, OnboardingLayoutComponent, SmLayoutComponent],
})
export class LayoutModule {}
